var map = {
	"./black-paper copy.png": 699,
	"./black-paper.png": 5710,
	"./black-rock copy.png": 4733,
	"./black-rock.png": 1834,
	"./black-scissors copy.png": 4084,
	"./black-scissors.png": 1328,
	"./blue-paper.png": 5319,
	"./blue-rock.png": 1730,
	"./blue-scissors.png": 4626,
	"./brown-paper.png": 3793,
	"./brown-rock.png": 3658,
	"./brown-scissors.png": 4232,
	"./darkwhite-paper.png": 3531,
	"./darkwhite-rock.png": 8434,
	"./darkwhite-scissors.png": 9679,
	"./green-paper.png": 5273,
	"./green-rock.png": 8670,
	"./green-scissors.png": 1442,
	"./lightbrown-paper.png": 3666,
	"./lightbrown-rock.png": 6507,
	"./lightbrown-scissors.png": 6025,
	"./white-paper.png": 3890,
	"./white-rock.png": 7337,
	"./white-scissors.png": 2148,
	"./yellow-paper.png": 1270,
	"./yellow-rock.png": 9826,
	"./yellow-scissors.png": 7929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4175;